import { render, staticRenderFns } from "./bpmDeputyList.vue?vue&type=template&id=47063a70&scoped=true&"
import script from "./bpmDeputyList.vue?vue&type=script&lang=js&"
export * from "./bpmDeputyList.vue?vue&type=script&lang=js&"
import style0 from "./bpmDeputyList.vue?vue&type=style&index=0&id=47063a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47063a70",
  null
  
)

export default component.exports